import types from './types';

const setIsShowing = isShowing => ({
  type: types.SET_IS_SHOWING,
  payload: {
    isShowing,
  },
});

const setScene = scene => ({
  type: types.SET_SCENE,
  payload: {
    scene,
  },
});

const setPodcastName = podcastName => ({
  type: types.SET_PODCAST_NAME,
  payload: {
    podcastName,
  },
});

const setPodcastDescription = podcastDescription => ({
  type: types.SET_PODCAST_DESCRIPTION,
  payload: {
    podcastDescription,
  },
});

const setPodcastItunesCategory = podcastItunesCategory => ({
  type: types.SET_PODCAST_ITUNES_CATEGORY,
  payload: {
    podcastItunesCategory,
  },
});

export default {
  setIsShowing,
  setScene,
  setPodcastName,
  setPodcastDescription,
  setPodcastItunesCategory,
};
